import { FC } from 'react';

export enum WidgetType {
    Slider = 'SSR_IMAGE_SLIDER',
    Cart = 'SSR_CART',
    AddToCart = 'SSR_ADD_TO_CART',
    OptionsVariations = 'SSR_OPTIONS_VARIATIONS',
    Breadcrumbs = 'SSR_BREADCRUMBS',
    CollectionSearch = 'SSR_COLLECTION_SEARCH',
    RuntimeFilterSort = 'SSR_FILTER_SORT',
    ProductPrice = 'SSR_PRODUCT_PRICE',
    ProductPriceOptions = 'SSR_PRODUCT_PRICE_OPTIONS',
    Accordion = 'SSR_ACCORDION',
    CalBooking = 'SSR_CAL_BOOKING',
    ProductCustomizations = 'SSR_PRODUCT_CUSTOMIZATIONS',
    FormFileInput = 'SSR_ADVANCED_FORM_FILE_INPUT',
    OrderConfirmation = 'SSR_ORDER_CONFIRMATION',
}

export type RuntimeWidget<T = any> = FC<T> & {
    skipHydration?: boolean;
};

export type BaseMetric = {
    id: string;
};

export interface CountMetric extends BaseMetric {
    type: 'COUNT';
}

export interface FieldMetric<TType extends 'MIN' | 'MAX'> extends BaseMetric {
    type: TType;
    field: string;
}

export type MinMetric = FieldMetric<'MIN'>;
export type MaxMetric = FieldMetric<'MAX'>;

export type Metric = CountMetric | MinMetric | MaxMetric;

export interface AggregationItem {
    id: string;
    groupBy: string[];
    unwind: string[];
    metrics: Metric[];
}

export interface Aggregation {
    name: string;
    aggregations: AggregationItem[];
}

export type AggregationMetricResultBase = {
    id: string;
    value: number;
};

export interface CountMetricResult extends AggregationMetricResultBase {
    type: 'COUNT';
}

export interface MinMetricResult extends AggregationMetricResultBase {
    type: 'MIN';
}

export interface MaxMetricResult extends AggregationMetricResultBase {
    type: 'MAX';
}

export type AggregationMetricResult =
    | CountMetricResult
    | MinMetricResult
    | MaxMetricResult;

export interface AggregationBucketResult {
    key: Record<string, string | number | boolean | null>;
    metrics: AggregationMetricResult[];
}

export interface AggregationResult {
    id: string;
    buckets: AggregationBucketResult[];
}

export interface ExecuteAggregationResult {
    aggregations: AggregationResult[];
}

export interface CollectionsAPI {
    enableAggregatePreview: () => CollectionsAPI;
    executeAggregation: (
        aggregation: Aggregation
    ) => Promise<ExecuteAggregationResult>;
    storeData: (name: string) => CollectionsAPI;
    pageSize: (value: number) => CollectionsAPI;
    pageNumber: (value: number) => CollectionsAPI;
    search: (value: string) => CollectionsAPI;
    where: (field: string, operator: string, value: string) => CollectionsAPI;
    get: () => {
        values: Array<object>;
        page: {
            pageNumber: number;
            totalPages: number;
        };
    };
}

export interface UserInfo {
    id: string;
}
